import Vue from "vue";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import store from "./store";
import App from "./app";
import "@/components";

import "normalize.css/normalize.css";
import "@/style/index.less";

// 远程脚本
import LoadScript from "vue-plugin-load-script";
import LoadStyle from "@/utils/load-style";

// 下拉树
import wl from "wl-vue-select";
import "wl-vue-select/lib/wl-vue-select.css";

// 剪切板 npm install vue-clipboard2 --save
import VueClipboard from "vue-clipboard2";

// 网站常量
import page from "@/constant/page";

// 过滤器
import filter from "@/filter";

// 枚举扩展
import "@/utils/enum-extension";

// 路由面包屑导航
import RouterBreadcrumb from "vue-router-breadcrumb";

Vue.use(wl);
Vue.use(VueClipboard);
Vue.use(filter);
Vue.use(Element, { size: "small" });
Vue.use(LoadScript);
Vue.use(LoadStyle);
Vue.use(page);
Vue.use(RouterBreadcrumb);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
